import {
    actionTypes as asyncTypes,
    isAsyncOperation,
    isAsyncComplete,
  } from "async-ops";
import { cloneDeep } from "lodash";
import { isMdaeWidgetOptionChangeEvent, updateStateAfterWidgetOptionChange } from "../../../../common_components/mdae-framework";
import { riskScoreWeightingItems } from "../constants";
import { GET_EM_UTILIZATION_CONFIG_REFERENCE_DATA } from "../services/get-reference-data";
export const SET_CONFIG_EM_UTILIZATION_DATA = "SET_CONFIG_EM_UTILIZATION_DATA";
export const IS_RECOMPILE_PROVIDER_DATA_VIEW_BUTTON_DISABLED = "IS_RECOMPILE_PROVIDER_DATA_VIEW_BUTTON_DISABLED";
export const IS_SAVE_AND_UNDO_BUTTON_DISABLED = "IS_SAVE_AND_UNDO_BUTTON_DISABLED";
export const RESET_EM_UTILIZATION_DATA = "RESET_EM_UTILIZATION_DATA";
export const INVALID_DATA_FIELDS = "INVALID_DATA_FIELDS";
export const TOGGLE_EM_UTILIZATION_WARNING_POPUP = "TOGGLE_EM_UTILIZATION_WARNING_POPUP";
export const SET_RISK_SCORE_WEIGHTING_DATSOURCE = "SET_RISK_SCORE_WEIGHTING_DATSOURCE";
export const IS_PROCESS_RUNNING = "IS_PROCESS_RUNNING";

const initialState = {
    isLoading: false,
    emCategoryList: [],
    normativeDataSourceList:[],
    defaultEmCategoryId:0,
    configureEmUtilizationData:{},
    isRecompileProviderDataViewButtonDisabled :true,
    defaultConfigureEmUtilizationData:{},
    isSaveAndUndoDisabled:true,
    resetEmUtilizationData:false,
    invalidEmUtilizationFields:[],
    riskScoreWeightingItems:riskScoreWeightingItems,
    unAssignedRiskScoreWeight:0,
    isProcessRunning:false
}

export default function (state = initialState, action) {
    let newState;
    switch (action.type) {
        case asyncTypes.OPERATION:
        case asyncTypes.COMPLETE:
        case asyncTypes.FAILURE:
            if (isAsyncOperation(GET_EM_UTILIZATION_CONFIG_REFERENCE_DATA)(action)) {
                return { ...state, emCategoryList: [],normativeDataSourceList:[] };
            }
            if (isAsyncComplete(GET_EM_UTILIZATION_CONFIG_REFERENCE_DATA)(action)) {
                const response = action.response;
                return { ...state, emCategoryList: response.emCategoryList,normativeDataSourceList:response.dataSourceList,isProcessRunning:response.isProcessRunning };
            }
            return state;
        case SET_CONFIG_EM_UTILIZATION_DATA:
        case IS_RECOMPILE_PROVIDER_DATA_VIEW_BUTTON_DISABLED:
        case IS_SAVE_AND_UNDO_BUTTON_DISABLED:
        case RESET_EM_UTILIZATION_DATA:
        case INVALID_DATA_FIELDS:
        case TOGGLE_EM_UTILIZATION_WARNING_POPUP:
        case SET_RISK_SCORE_WEIGHTING_DATSOURCE:
        case IS_PROCESS_RUNNING:
            newState = cloneDeep(state);
            if (isMdaeWidgetOptionChangeEvent(action.data)) {
                newState = updateStateAfterWidgetOptionChange(newState, action.data);
            } else {
                newState = { ...newState, ...action.data };
            }
            return newState;
        default:
            return state;
    }
}